import { DOC_TYPES_ENUM, CHAT_TYPES_ENUM } from "../../../types/enums";


export const findNotificationChatType = (docType: string) => {
  if (docType === DOC_TYPES_ENUM.ORDER || docType === DOC_TYPES_ENUM.ORDER_PCR) {
    return CHAT_TYPES_ENUM.ORDER;
  }

  return CHAT_TYPES_ENUM.REQUISITION;
}